module.exports = __webpack_public_path__ + "static/media/item-row-gold.701c8940.png";